import { MapPin, ShoppingCart, User } from 'lucide-react';
import { Button } from './ui/button';
import { UserMenuDrawer } from './UserMenuDrawer';
import { useCart } from '@/contexts/CartContext';
import { useAuth } from '@/contexts/AuthContext';
import { useLocation } from '@/contexts/useLocation';
import { useState } from 'react';
import { LoginDialog } from './LoginDialog';
import { LocationDialog } from './LocationDialog';
import { CartDrawer } from './CartDrawer';
import { SearchBox } from './SearchBox';
import { Link } from 'react-router-dom';

export const Header = ({ onSearch }: { onSearch?: (query: string) => void }) => {
  const { cart, setIsCartOpen } = useCart();
  const { isAuthenticated } = useAuth();
  const { location } = useLocation();
  const [showLoginDialog, setShowLoginDialog] = useState(false);
  const [showLocationDialog, setShowLocationDialog] = useState(false);
  const [showUserMenuDrawer, setShowUserMenuDrawer] = useState(false);

  const cartItemsCount = cart.reduce((sum, item) => sum + item.quantity, 0);

  const handleCartClick = () => {
    setIsCartOpen(true);
  };

  const handleUserIconClick = () => {
    if (!isAuthenticated) {
      setShowLoginDialog(true);
    } else {
      setShowUserMenuDrawer(true);
    }
  };

  return (
    <>
      <header className="border-b bg-background sticky top-0 z-50">
        <div className="container mx-auto px-4 py-3">
          <div className="flex items-center justify-between gap-2 mb-3">
            <div className="flex items-center gap-2">
              <Link to="/" className="flex items-center">
                <img src="/logoFinal.svg" alt="Indispare Logo" className="h-8 md:h-10 w-auto" />
              </Link>
            </div>
            <SearchBox className="hidden md:flex flex-1 mx-4" placeholder='Search for Products' onSearch={onSearch}/>
            <div className="flex items-center gap-2 md:gap-4">
              <Button variant="ghost" size="sm" className="flex items-center gap-1 md:gap-2 px-2 md:px-3" onClick={() => setShowLocationDialog(true)}>
                <MapPin className="h-5 w-5 flex-shrink-0" />
                {location ? (
                  <span className="text-sm hidden lg:inline-block max-w-[150px] truncate">
                    {location.city || location.address}
                    {location.postalCode && (
                      <span className="ml-1 text-xs text-muted-foreground">
                        ({location.postalCode})
                      </span>
                    )}
                  </span>
                ) : (
                  <span className="text-sm hidden lg:inline-block text-muted-foreground">Set location</span>
                )}
              </Button>
              <Button variant="ghost" size="icon" onClick={handleUserIconClick}>
                <User className="h-5 w-5" />
              </Button>
              <CartDrawer>
                <Button variant="ghost" size="icon" className="relative" onClick={handleCartClick}>
                  <ShoppingCart className="h-5 w-5" />
                  {cartItemsCount > 0 && (
                    <span className="absolute -top-1 -right-1 bg-primary text-primary-foreground text-xs rounded-full h-5 w-5 flex items-center justify-center">
                      {cartItemsCount}
                    </span>
                  )}
                </Button>
              </CartDrawer>
            </div>
          </div>
          <SearchBox className="md:hidden mb-3" placeholder='Search for "Bearing"' />
        </div>
      </header>
      <LoginDialog open={showLoginDialog} onOpenChange={setShowLoginDialog} />
      <LocationDialog open={showLocationDialog} onOpenChange={setShowLocationDialog} />
      <UserMenuDrawer open={showUserMenuDrawer} onOpenChange={setShowUserMenuDrawer} />
    </>
  );
};
